    
<template>
  <common-page-layout v-if="sysadmin || adminrights">     
    <!-- <span slot="fixedtopbuttons">
    
    
      <add-button @click="$refs.remedialdialog.add({business})"/>
      <add-button @click="$refs.remedialdialog.lodge({business})">Lodge</add-button>   
    
      
    </span> -->

    <!-- <large-button-wide class="w3-theme-dark" v-if="sysadmin || adminrights.write || adminrights.createremedials" @click="$router.push('/admin/customerremedials/lodged')">Lodged Remedials</large-button-wide> -->

    <large-button-wide class="w3-theme-dark"  @click="$router.push('/admin/customerremedials/processing')">Current Remedials</large-button-wide>
    <!-- <large-button-wide class="w3-theme-dark"  @click="$router.push({name:'AdminRemedialsProcessing',params: { assigned: true}})">My Remedials</large-button-wide> -->

    <!-- <large-button-wide class="w3-theme-dark" v-if="sysadmin || adminrights.read || adminrights.write" @click="$router.push('/admin/customerremedials/declined')">Declined Remedials</large-button-wide> -->

  </common-page-layout>
</template>

<script>
  import {
    mapGetters
    
  } from "vuex";
 
  export default {  
    computed: {
      ...mapGetters(["adminrights","sysadmin","business"])
    }
  
  };
</script>



// WEBPACK FOOTER //
// src/components/admin/customerremedials/AdminCustomersRemedialsHome.vue